import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";

const ServiceCard = ({ s, i }) => (
  <Reveal delay={i * 0.1} className="h-full">
    <div
      className="group relative flex h-full flex-col border border-line bg-surface p-5 transition-[border-color,background-color] duration-300 hover:border-accent sm:p-6"
      data-testid={`service-card-${s.id}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img src={s.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.06]" />
        <span className="absolute left-0 top-0 bg-accent px-3 py-1.5 font-mono text-[12px] text-accent-ink">{s.index}</span>
      </div>
      <div className="flex flex-1 flex-col px-1 pb-1 pt-7">
        <h3 className="font-display text-[1.75rem] font-semibold leading-tight tracking-[-0.03em] text-ink sm:text-3xl">{s.title}</h3>
        <p className="mt-4 text-[15px] leading-relaxed text-muted">{s.body}</p>
        <ul className="mt-6 divide-y divide-line border-y border-line text-[14px] text-ink">
          {s.points.map((p) => (
            <li key={p} className="py-2.5">{p}</li>
          ))}
        </ul>
        <div className="mt-auto flex flex-wrap items-center gap-x-6 gap-y-3 pt-7">
          {/* Stretched link: the whole card is clickable */}
          <Link
            to={s.to}
            className="inline-flex items-center gap-2 text-[14px] font-medium text-accent after:absolute after:inset-0 after:content-['']"
            data-testid={`service-card-${s.id}-link`}
          >
            Explore {s.title.split(" ")[0]}
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
          {s.extra && (
            <Link to={s.extra.to} className="relative z-10 text-[13px] text-muted underline decoration-line underline-offset-4 transition-colors hover:text-accent" data-testid={`service-card-${s.id}-extra-link`}>
              {s.extra.label}
            </Link>
          )}
        </div>
      </div>
    </div>
  </Reveal>
);

export const ServiceCards = ({ services = [] }) => (
  <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="service-cards">
    {services.map((s, i) => (
      <ServiceCard key={s.id} s={s} i={i} />
    ))}
  </div>
);
